import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  transcriptSettingsTitle: {
    id: 'course-authoring.video-uploads.transcriptSettings.title',
    defaultMessage: 'Transcript settings',
    description: 'Title for transcript settings sheet',
  },
  invalidCielo24TranscriptionPlanMessage: {
    id: 'course-authoring.video-uploads.transcriptSettings.cielo24.errorAlert.message',
    defaultMessage: 'No transcription plans found for Cielo24.',
  },
  invalid3PlayMediaTranscriptionPlanMessage: {
    id: 'course-authoring.video-uploads.transcriptSettings.3PlayMedia.errorAlert.message',
    defaultMessage: 'No transcription plans found for 3PlayMedia.',
  },
  errorAlertMessage: {
    id: 'course-authoring.video-uploads.transcriptSettings.errorAlert.message',
    defaultMessage: '{message}',
  },
  orderTranscriptsTitle: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.title',
    defaultMessage: 'Order transcripts',
    description: 'Title for order transcript collapsible',
  },
  noneLabel: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.none.label',
    defaultMessage: 'None',
    description: 'Label for order transcript None option',
  },
  cieloLabel: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.cielo24.label',
    defaultMessage: 'Cielo24',
    description: 'Label for order transcript Cieol24 option',
  },
  threePlayMediaLabel: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.3PlayMedia.label',
    defaultMessage: '3Play Media',
    description: 'Label for order transcript 3Play Media option',
  },
  updateSettingsLabel: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.updateSettings.label',
    defaultMessage: 'Update settings',
    description: 'Label for  order transcript update settings button',
  },
  discardSettingsLabel: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.discardSettings.label',
    defaultMessage: 'Discard changes',
    description: 'Label for order transcript discard settings button',
  },
  lastUpdatedMessage: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.lastUpdated.message',
    defaultMessage: 'Last updated',
    description: 'Message that lets user know when the update was made to transcript settings',
  },
  threePlayMediaTurnaroundLabel: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.3PlayMedia.turnaround.label',
    defaultMessage: 'Transcript turnaround',
    description: 'Label for 3Play Media transcript turnaround dropdown',
  },
  threePlayMediaTurnaroundPlaceholder: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.3PlayMedia.turnaround.dropdown.placeholder',
    defaultMessage: 'Select turnaround',
    description: 'Label for 3Play Media transcript turnaround dropdown placeholder',
  },
  threePlayMediaSourceLanguageLabel: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.3PlayMedia.sourceLanguage.label',
    defaultMessage: 'Video source language',
    description: 'Label for 3Play Media video source language dropdown',
  },
  threePlayMediaSourceLanguagePlaceholder: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.3PlayMedia.sourceLanguage.dropdown.placeholder',
    defaultMessage: 'Select language',
    description: 'Label for 3Play Media video source language dropdown placeholder',
  },
  threePlayMediaTranscriptLanguageLabel: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.3PlayMedia.transcriptLanguage.label',
    defaultMessage: 'Transcript language',
    description: 'Label for 3Play Media video source language dropdown',
  },
  threePlayMediaTranscriptLanguagePlaceholder: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.3PlayMedia.transcriptLanguage.dropdown.placeholder',
    defaultMessage: 'Select language(s)',
    description: 'Label for 3Play Media transcript  language dropdown placeholder',
  },
  threePlayMediaCredentialMessage: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.3PlayMedia.credential.message',
    defaultMessage: 'Enter the account information for your organization.',
    description: 'Message for 3Play Media credential view',
  },
  threePlayMediaApiKeyLabel: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.3PlayMedia.apiKey.label',
    defaultMessage: 'API key',
    description: 'Label for 3Play Media API key input',
  },
  threePlayMediaApiSecretLabel: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.3PlayMedia.apiSecret.label',
    defaultMessage: 'API secret',
    description: 'Label for 3Play Media API secret input',
  },
  cieloTurnaroundLabel: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.cielo24.turnaround.label',
    defaultMessage: 'Transcript turnaround',
    description: 'Label for Cielo24 transcript turnaround dropdown',
  },
  cieloTurnaroundPlaceholder: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.cielo24.turnaround.dropdown.placeholder',
    defaultMessage: 'Select turnaround',
    description: 'Label for Cielo24 transcript turnaround dropdown placeholder',
  },
  cieloFidelityLabel: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.cielo24.fidelity.label',
    defaultMessage: 'Transcript fidelity',
    description: 'Label for Cielo24 transcript fidelity dropdown',
  },
  cieloFidelityPlaceholder: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.cielo24.fidelity.dropdown.placeholder',
    defaultMessage: 'Select fidelity',
    description: 'Label for Cielo24 transcript fidelity dropdown placeholder',
  },
  cieloSourceLanguageLabel: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.cielo24.sourceLanguage.label',
    defaultMessage: 'Video source language',
    description: 'Label for Cielo24 video source language dropdown',
  },
  cieloSourceLanguagePlaceholder: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.cielo24.sourceLanguage.dropdown.placeholder',
    defaultMessage: 'Select language',
    description: 'Label for Cielo24 video source language dropdown placeholder',
  },
  cieloTranscriptLanguageLabel: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.cielo24.transcriptLanguage.label',
    defaultMessage: 'Transcript language',
    description: 'Label for Cielo24 video source language dropdown',
  },
  cieloTranscriptLanguagePlaceholder: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.cielo24.transcriptLanguage.dropdown.placeholder',
    defaultMessage: 'Select language',
    description: 'Label for Cielo24 transcript  language dropdown placeholder',
  },
  cieloCredentialMessage: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.cielo24.credential.message',
    defaultMessage: 'Enter the account information for your organization.',
    description: 'Message for Cielo24 credential view',
  },
  cieloApiKeyLabel: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.cielo24.apiKey.label',
    defaultMessage: 'API key',
    description: 'Label for Cielo24 API key input',
  },
  cieloUsernameLabel: {
    id: 'course-authoring.video-uploads.transcriptSettings.orderTranscripts.cielo24.username.label',
    defaultMessage: 'Username',
    description: 'Label for Cielo24 username input',
  },
});

export default messages;
